import UICheckBox from './UICheckBox';
export default UICheckBox;